import _ from 'lodash'
import type {ReactElement} from 'react'
// Components
import BoundLink from '../bound-link'
import StartButton, {groupIsNotReady} from '../start-button'
// Utils
import slugify from '../../utils/slugify'
import {isBallotScheduledAlreadyEnded, isBallotScheduledNotStarted} from '../../utils/ballot-access'
// Types
import type {Ballot, BallotPageBlock, ParentCategory} from '../../types/ballot'
// Styles
import styles from '../start-button.module.scss'

interface StartButtonBlockProps {
  ballot: Ballot
  block: BallotPageBlock
}

const getFirstSelectedGroup = (block: BallotPageBlock): ParentCategory | null => {
  return _.first(block.formValuesObject.blockSelectedGroup) || null
}

const getGroupHref = (group: ParentCategory | null): string | null => {
  if (!group) return null

  const questions = _.filter(group.sub_categories, question => Boolean(question?.name))
  const sortedQuestions = (
    group.sort_order === 'manual'
      ? questions
      : [...questions].sort((a, b) => a?.name?.trim()?.localeCompare(b?.name?.trim()))
  )
  const firstQuestion = _.first(sortedQuestions)

  if (!firstQuestion?.name) return null

  return `/${slugify(group.parent_category_name)}/${slugify(firstQuestion.name)}`
}

const StartButtonBlock = ({ballot, block}: StartButtonBlockProps): ReactElement | null => {
  const buttonText = block.formValuesObject.blockButtonText
  const selectedGroup = getFirstSelectedGroup(block)
  const href = getGroupHref(selectedGroup)

  const isBallotNotActive = isBallotScheduledAlreadyEnded(ballot) || isBallotScheduledNotStarted(ballot)

  if (!buttonText || !href || groupIsNotReady(ballot, selectedGroup) || isBallotNotActive) {
    return <StartButton ballot={ballot} group={selectedGroup} />
  }

  return (
    <BoundLink
      href={href}
      className={`button is-dark is-large ${styles['start-button']}`}
    >
      {buttonText}
    </BoundLink>
  )
}

export default StartButtonBlock
